







































































import AbpBase from "../../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetBedList, InsertBed, UpdateBedById, DeleteBed, GetWardList} from '../../../../api/specialDictionary'
import {GetPinYin, GetWuBi} from '../../../../api/sys'
import {GetListByCode} from "@/api/configureDictionary"
import {GetMachineListByWardOrChangJ} from "@/api/engineer"

@Component
export default class Country extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'bedcode',
			title: '床位名称'
		},
		{
			key: 'wardName',
			title: '病区'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {
		machinecode : -1
	}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	wards = [] //  病区下拉
	machines = []  //  透析机下拉
	created() {
		this.getData()
		this.getSelects()
	}

	//获取拼音五笔
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.wardPY = res1
		this.dialogForm.wardWB = res2
	}

	async getSelects() {
		let res = await GetWardList({SkipCount:1,MaxResultCount:10000})
		this.wards = res.items
		this.getMachines(-1)
	}

	async getMachines(val: any){
		let query: any = {SkipCount:1,MaxResultCount:10000}
		if (val !== -1) {
			query.WardID = val
		}
		let res1 = await GetMachineListByWardOrChangJ(query)
		this.machines = res1.items
		this.dialogForm.machinecode = ''
	}

	createCounty() {
		this.dialogTitle = '新增床位'
		this.dialogForm = {
			status: true,
			machinecode : ''
		}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetBedList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑床位'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteBed({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}

	async confirm() {
		if (this.dialogTitle === '新增床位') {
			let res = await InsertBed(this.dialogForm)
		} else if (this.dialogTitle === '编辑床位') {
			let res = await UpdateBedById(this.dialogForm)
		}
		this.dialogFormVisible = false
		this.getData()
	}

	rules = {
		bedcode: [{required: true, message: '请输入内容', trigger: 'blur'}],
		wardCode: [{required: true, message: '请选择', trigger: 'blur'}],
		machinecode: [{required: true, message: '请选择', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	addModalVisibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false
		}
	}

	wardChange(val: any){
		this.getMachines(val)
		this.dialogForm.wardId = val
		this.wards.forEach((item:any) => {
			if (item.id === val) {
				this.dialogForm.wardName = item.wardName
			}
		})
	}

	machineChange(val: any){
		this.dialogForm.machineId = val
	}

	// (val: any){
	// 	this.wards.forEach((item:any) => {
	// 		if (item.id === val) {
	// 			this.dialogForm.wardName = item.wardName
	// 		}
	// 	})
	// }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/machine/parts/bed.vue